<template lang="html">
  <vs-card
    class="cardx card-100-h"
    v-bind:style="{ 'min-height': windowHeight - 155 + 'px' }"
  >
    <div>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
          <form
            @submit.prevent="saveStation"
            class="columns column is-multiline is-12"
            data-vv-scope="station"
          >
            <h3>Edit station</h3>
            <div class="mb-4">
              <vs-input
                val-icon-danger="close"
                class="inputx"
                :danger="errors.has('name')"
                v-validate="'required'"
                :danger-text="errors.has('name') ? errors.first('name') : null"
                name="name"
                label="Name"
                placeholder="Name"
                v-model="station_form.name"
                style="width: 100%"
              />
            </div>
            <div class="mb-4">
              <vs-input
                val-icon-danger="close"
                class="inputx"
                :danger="errors.has('description')"
                v-validate="'required|min:5'"
                :danger-text="
                  errors.has('description') ? errors.first('description') : null
                "
                name="description"
                label="Description"
                placeholder="Description"
                v-model="station_form.description"
                style="width: 100%"
              />
            </div>

            <div class="mb-4">
              <vs-input
                val-icon-danger="close"
                class="inputx"
                :danger="errors.has('address')"
                v-validate="'required'"
                :danger-text="
                  errors.has('address') ? errors.first('address') : null
                "
                name="address"
                label="Address"
                placeholder="Address"
                v-model="station_form.address"
                style="width: 100%"
              />
            </div>

            <vs-row class="mb-4">
              <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  type="number"
                  val-icon-danger="close"
                  class="inputx"
                  :danger="errors.has('latitude')"
                  v-validate="'required'"
                  :danger-text="
                    errors.has('latitude') ? errors.first('latitude') : null
                  "
                  name="latitude"
                  label="Latitude"
                  placeholder="Latitude"
                  v-model="station_form.latitude"
                  style="width: 100%"
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  type="number"
                  val-icon-danger="close"
                  class="inputx"
                  :danger="errors.has('longitude')"
                  v-validate="'required'"
                  :danger-text="
                    errors.has('longitude') ? errors.first('longitude') : null
                  "
                  name="longitude"
                  label="Longitude"
                  placeholder="Longitude"
                  v-model="station_form.longitude"
                  style="width: 100%"
                />
              </vs-col>
            </vs-row>

            <div class="mb-4">
              <label class="vs-input--label">Keywords</label>
              <vs-chips
                color="rgb(145, 32, 159)"
                label="Keywords"
                placeholder="Add keywords"
                v-model="station_form.keywords"
              >
                <vs-chip
                  :key="chip"
                  @click="station_form.keywords.splice(idx, 1)"
                  v-for="(chip, idx) in station_form.keywords"
                  closable
                >
                  {{ chip }}
                </vs-chip>
              </vs-chips>
            </div>

            <div class="mb-4">
              <ImgInputer
                :img-src="
                  station_form.image && !image ? station_form.image : null
                "
                placeholder="Drop image here or click"
                bottom-text="Drop file here or click to change"
                v-model="image"
                accept="image/*"
                theme="light"
                @onChange="fileChange"
              />
            </div>

            <div class="">
              <vs-button
                class="mr-3"
                color="primary"
                @click="saveStation"
                type="filled"
                >Save</vs-button
              >
            </div>
          </form>
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div>
            <div
              class="vs-con-input"
              style="width: calc(100% - 10px); margin: 10px"
            >
              <input
                v-model="place"
                id="inputPlace"
                placeholder="Search a place or address"
                type="text"
                class="vs-inputx vs-input--input normal"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
              />
            </div>
            <LMap
              :zoom="14"
              :center="[
                station_form.latitude || 19.41266,
                station_form.longitude || -99.141134,
              ]"
              style="height: calc(100vh - 308px)"
            >
              <LTileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
              />

              <LMarker
                v-if="station_form.latitude && station_form.longitude"
                :lat-lng="[station_form.latitude, station_form.longitude]"
                :icon="stationIcon"
                :draggable="true"
                @dragend="onDragend"
              >
                <LPopup>{{ station_form.name || "New Station" }}</LPopup>
              </LMarker>
            </LMap>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </vs-card>
</template>

<style scoped>
.card-100-h {
  height: calc(100% - 110px);
}
.mr-3 {
  margin-right: 3rem;
}
.mb-2 {
  margin-bottom: 2rem;
}
.mb-4 {
  margin-bottom: 4rem;
}
.icon-sm {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.vs-list--item {
  background-color: white;
}
</style>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { mapActions, mapGetters } from "vuex";
import ImgInputer from "vue-img-inputer";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const color = "rgb(115, 103, 240)";
export default {
  name: "EditStation",
  components: {
    ImgInputer,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      title: "",
      google: null,
      windowHeight: 0,
      map: null,

      viewType: "form",
      formTitle: "",
      drawingManager: null,
      selectedShape: null,

      station_form_icon: null,
      stationIcon: L.icon({
        iconUrl: "/img/red-dot-1.png",
        iconSize: [22, 22],
        iconAnchor: [11, 11],
      }),

      station_form: {
        latitude: null,
        longitude: null,
        keywords: [],
        is_active: true,
      },
      autocomplete: null,
      place: null,
      onSubmit: false,
      image: null,
    };
  },
  computed: {
    ...mapGetters("users", ["userCan"]),
  },
  created() {
    if (this.$route.params.id) {
      this.title = "Edit station";
      this.getStation({ id: this.$route.params.id })
        .then((data) => {
          let form = _.cloneDeep(data);
          form.zone_id = form.zone.id;
          delete form.zone;
          this.station_form = form;
          if (this.map) {
            this.map.panTo({ lat: form.latitude, lng: form.longitude });
            this.map.setZoom(18);
          }
        })
        .catch((error) => {
          if (error) {
            if (error.status === 404) {
              this.$router.push({ name: "page-error-404" });
            }
          }
        });
    } else {
      this.title = "New station";
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;

      this.station_form_icon = {
        url: "/img/red-dot-1.png",
        scaledSize: new google.maps.Size(22, 22),
        anchor: new google.maps.Point(11, 11),
      };

      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: false,
        markerOptions: {
          draggable: true,
          visible: false,
        },
      });
      this.drawingManager.setMap(this.map);

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (e) => {
          this.drawingManager.setDrawingMode(null);
          let newShape = e.overlay;
          newShape.type = e.type;
          if (newShape.type === "marker") {
            this.station_form.latitude = newShape.getPosition().lat();
            this.station_form.longitude = newShape.getPosition().lng();
          }
        }
      );

      let input = document.getElementById("inputPlace");
      let options = {
        componentRestrictions: { country: "mx" },
      };

      this.autocomplete = new google.maps.places.Autocomplete(input, options);
      this.autocomplete.addListener("place_changed", this.onPlaceChanged);

      if (this.station_form.latitude && this.station_form.longitude) {
        this.map.panTo({ lat: form.latitude, lng: form.longitude });
        this.map.setZoom(18);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions("routes", ["getStation", "getStations", "updateStation"]),
    onResize() {
      this.windowHeight = window.innerHeight;
    },

    saveStation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading({
            type: "point",
          });
          let payload = _.cloneDeep(this.station_form);
          if (!this.image) {
            delete payload.image;
          }
          this.updateStation(payload)
            .then((data) => {
              this.$vs.loading.close();
              this.$router.push({ name: "routes.stations" });
            })
            .catch((error) => {
              this.$vs.loading.close();
              if (error) {
                if (error.status === 409) {
                  this.setErrors(error.data.errors);
                }
              }
            });
        }
      });
    },
    onPlaceChanged() {
      this.viewType = "station-form";
      let place = this.autocomplete.getPlace();
      this.station_form.latitude = place.geometry.location.lat();
      this.station_form.longitude = place.geometry.location.lng();
      this.station_form.name = place.name;
      this.station_form.address = place.formatted_address;
      if (place.geometry) {
        this.map.panTo(place.geometry.location);
        this.map.setZoom(15);
      }
    },
    onDragend(coordinate) {
      this.station_form.latitude = coordinate.latLng.lat();
      this.station_form.longitude = coordinate.latLng.lng();
    },
    fileChange(file, filename) {
      let reader = new FileReader();
      reader.readAsDataURL(this.image);
      reader.onload = () => {
        this.station_form.image = reader.result.split(",").pop();
      };
    },
    setErrors(errors) {
      for (let key in errors) {
        if (Array.isArray(errors[key])) {
          this.errors.add({
            field: key,
            msg: errors[key][0],
          });
        }
      }
    },
  },
};
</script>
